import * as types from './types'
import {RSAA} from "redux-api-middleware";

export function getCreativeTasks(instance_id, values) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/instance/${instance_id}/creative-tasks`,
            method: 'POST',
            headers: types.defaultHeaders,
            types: [
                types.CREATIVE_TASKS_LIST,
                types.CREATIVE_TASKS_LIST_SUCCESS,
                types.CREATIVE_TASKS_LIST_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}

export function submitCreativeTask(instance_id, task_id, values) {

    const data = new FormData();
    if (values.attachment !== undefined) {
        data.append('attachment', values.attachment);
    }
    data.append('note', values.note);
    data.append('task_id', task_id);

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/instance/${instance_id}/creative-tasks/submit`,
            method: 'POST',
            types: [
                { type: types.CREATIVE_TASKS_SUBMIT, meta: { id: task_id } },
                { type: types.CREATIVE_TASKS_SUBMIT_SUCCESS, meta: { id: task_id } },
                types.CREATIVE_TASKS_SUBMIT_ERROR
            ],
            credentials: 'same-origin',
            body: data
        },
        auth: true
    };
}
